import { pluralize } from '@travelata-libs/utils';

export default Backbone.Epoxy.Model.extend({
    defaults: {
        id: null,
        type: null,
        price: null,

        discount: null,
        description: null,
        hash: null,
        firstPayment: 1,
        medicalInsurance: null,
        transferType: null,
        tourCriteria: null,
        actualizeInProgress: false,
        firstPaymentDefinition: null,
        isExclusive: false,
        nights: null,
        transferDescription: null,
        nightsInHotel: null,
        tour: null,
        hotelOffer: null,
        railwayTour: null,
        similarProducts: [],
    },
    computeds: {
        tourProducts: {
            deps: ['similarProducts'],
            get: (similarProducts) => _.filter(similarProducts, (similarProduct) => similarProduct.get('type') === 'TourProduct'),
        },
        hotelOfferProducts: {
            deps: ['similarProducts'],
            get: (similarProducts) => _.filter(similarProducts, (similarProduct) => similarProduct.get('type') === 'HotelOfferProduct'),
        },
        railwayProducts: {
            deps: ['similarProducts'],
            get: (similarProducts) => _.filter(similarProducts, (similarProduct) => similarProduct.get('type') === 'RailwayTourProduct'),
        },
        cheapestTourProduct: {
            deps: ['tourProducts'],
            get(tourProducts) {
                if (this.get('type') === 'TourProduct') {
                    return this;
                }
                return tourProducts?.[0] || null;
            },
        },
        cheapestHotelOfferProduct: {
            deps: ['hotelOfferProducts'],
            get(hotelOfferProducts) {
                if (this.get('type') === 'HotelOfferProduct') {
                    return this;
                }
                return hotelOfferProducts?.[0] || null;
            },
        },
        cheapestRailwayProduct: {
            deps: ['railwayProducts'],
            get(railwayProducts) {
                if (this.get('type') === 'RailwayTourProduct') {
                    return this;
                }
                return railwayProducts?.[0] || null;
            },
        },
        product: {
            deps: ['tour', 'hotelOffer', 'railwayTour'],
            get(tour, hotelOffer, railwayTour) {
                return tour || hotelOffer || railwayTour || null;
            },
        },
        roomsTouristGroup: {
            deps: ['product'],
            get: (product) => {
                return product.get('roomGroups')?.reduce((acc, r) => {
                    acc.adults += r.touristGroup.adults;
                    acc.kids += r.touristGroup.kids;
                    acc.infants += r.touristGroup.infants;
                    acc.kidsAges?.push(...(r.touristGroup.kidsAges || []));
                    return acc;
                }, { adults: 0, kids: 0, kidsAges: [], infants: 0 });
            },
        },
        touristText: {
            deps: ['roomsTouristGroup', 'product'],
            get: (roomsTouristGroup, product) => {
                const { adults, kids, infants } = roomsTouristGroup;
                const touristCount = adults + kids + infants;
                const touristText = pluralize(['туриста', 'туристов', 'туристов'], touristCount);
                const roomsText = pluralize(['номер', 'номера', 'номеров'], product.get('roomGroups').length);
                return `${roomsText} для ${touristText}`;
            },
        },
        roomsPriceText: {
            deps: ['product'],
            get: (product) => {
                const roomsLength = product.get('roomGroups').length;
                const text = pluralize(['номер', 'номера', 'номеров'], roomsLength, false);
                return `Цена за ${roomsLength} ${text}`;
            },
        },
        dateFrom: {
            deps: ['product'],
            get: (product) => product.get('checkInDateRange').get('from').getTime(),
        },
        freeCancellationHotelOffer: {
            deps: ['hotelOfferProducts', 'hotelOffer'],
            get(hotelOfferProducts, hotelOffer) {
                return !!this.getCancellationPolicy(hotelOffer)?.freeCancellationDateBefore
                    || !!_.find(hotelOfferProducts, (similarHotelOffer) => !!this.getCancellationPolicy(similarHotelOffer)?.freeCancellationDateBefore);
            },
        },
    },
    getCancellationPolicy: (product) => (product?.get('hotelOffer') || product)?.get('cancellationPolicy'),
});